import cemetery from '../../../../assets/svgs/actors/anaHowie/cemetery'

import { CEMETERY } from '../../../../constants/scene/actors/songs'

export default {
    [CEMETERY]: cemetery,
}
